module.exports = __webpack_public_path__ + "media/images/category_icons/podcasts-3c43383a5036cb12b03485a36177def1.svg";